import React, {useState} from 'react';
import {observer} from 'mobx-react-lite';

import {ModalConfirm} from '../../../../components/ModalConfirm';
import {MaterialUiInput} from '../../../../components/form/material-ui-input/MaterialUiInput';

import './DeleteWithNameConfirm.css';

export interface DeleteWithNameConfirmProps {
    header: string;
    text: React.ReactNode;
    confirmText: string;
    expectedValue: string;
    onConfirm: () => Promise<void>;
    onClose: () => void;
    inputLabel?: string;
}

export const DeleteWithNameConfirm = observer(({
    header,
    text,
    confirmText,
    expectedValue,
    onConfirm,
    onClose,
    inputLabel = expectedValue,
}: DeleteWithNameConfirmProps) => {
    const [value, setValue] = useState('');

    return (
        <ModalConfirm
            open={true}
            type={'danger'}
            header={header}
            onConfirm={onConfirm}
            confirmText={confirmText}
            onClose={onClose}
            onCancel={onClose}
            canConfirm={value === expectedValue}
        >
            <div>
                {text}
                <MaterialUiInput
                    className="DeleteWithNameConfirm"
                    label={inputLabel}
                    onChange={setValue}
                    value={value}
                    name='delete-confirm'
                    fullWidth={true}
                    isRequired={true}
                />
            </div>
        </ModalConfirm>
    );
});
